import { useMemo } from 'react'

import { useLottie } from 'lottie-react'

import couponBronze from '@/assets/icons/coupon-bronze.webp'
import couponGold from '@/assets/icons/coupon-gold.webp'
import couponSilver from '@/assets/icons/coupon-silver.webp'
import confettiBurst from '@/assets/lottie/confetti-burst.json'
import confettiPulming from '@/assets/lottie/confetti-pulming.json'

import { LottieWrapper } from './styles'

interface ConfettiLottieProps {
  rewardTier: number
  isMinor: boolean
}

/** rewardTier → Lottie 내부에 교체할 쿠폰 이미지 URL */
const COUPON_IMAGE_BY_TIER: Record<number, string> = {
  2: couponGold,
  3: couponSilver,
  4: couponBronze,
  5: couponBronze,
}

/** Lottie JSON의 assets[0] 이미지를 Vite 에셋 URL로 교체한 복사본을 반환 */
const replaceAssetImage = (lottieJson: typeof confettiBurst, imageUrl: string) => {
  const cloned = structuredClone(lottieJson)
  if (cloned.assets?.[0]) {
    cloned.assets[0].p = imageUrl
    cloned.assets[0].u = ''
    cloned.assets[0].e = 0
  }
  return cloned
}

export default function ConfettiLottie({ rewardTier, isMinor }: ConfettiLottieProps) {
  const animationData = useMemo(() => {
    if (isMinor) return confettiPulming

    const imageUrl = COUPON_IMAGE_BY_TIER[rewardTier]
    if (!imageUrl) return confettiBurst

    return replaceAssetImage(confettiBurst, imageUrl)
  }, [rewardTier, isMinor])

  const { View } = useLottie({
    animationData,
    loop: false,
    style: isMinor ? { overflow: 'visible' } : undefined,
  })

  return <LottieWrapper>{View}</LottieWrapper>
}
